import { render, staticRenderFns } from "./ActivityPhotosField.vue?vue&type=template&id=13267cd4&scoped=true"
import script from "./ActivityPhotosField.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityPhotosField.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ActivityPhotosField.vue?vue&type=style&index=0&id=13267cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13267cd4",
  null
  
)

export default component.exports